import Icon from "@mdi/react";
import { mdiEmail, mdiMapMarker, mdiPhone } from "@mdi/js";

import { useHead } from "../services/common";

import Content from "../components/Content";
import { useLang } from "../components/Language";
import Footer from "../components/Footer";
import { Header } from "../components";


export default function Contact() {
    const lang = useLang();

    useHead(
        lang === "cs" ? "Kontaktujte nás" : "Skontaktuj się z nami",
        `${lang === "cs" ? "Kontaktujte nás" : "Skontaktuj się z nami"} | Jilemnicko - společenství obcí`
    );

    return <>
        <Header title="Kontakt" background="kontakt" />
        <main style={{ marginBottom: "-50px" }}>
            <section className="contact-page">
                <div className="image" />
                <div className="text">
                    <h1>{lang === "cs" ? "Kontaktujte nás" : "Skontaktuj się z nami"}</h1>
                    <ul>
                        <li>
                            <a href="tel:+420737529723">
                                <span className="icon"><Icon path={mdiPhone} size={1.2} /></span>
                                <h2>Telefon</h2>
                                <span className="value">+420 737 529 723</span>
                            </a>
                        </li>

                        <li>
                            <a href="mailto:jilemnicko@jilemnicko-so.cz">
                                <span className="icon"><Icon path={mdiEmail} size={1.2} /></span>
                                <h2>E-mail</h2>
                                <span className="value">jilemnicko@jilemnicko-so.cz</span>
                            </a>
                        </li>

                        <li>
                            <a target="_blank" href="https://maps.app.goo.gl/Gpqj9zEPJ9omniGZ6">
                                <span className="icon"><Icon path={mdiMapMarker} size={1.2} /></span>
                                <h2>{lang === "cs" ? "Adresa sídla" : "Adres siedziby"}</h2>
                                <span className="value">Masarykovo náměstí 82,<br />
                                    514 01 Jilemnice</span>
                            </a>
                        </li>
                        <li>
                            <a target="_blank" href="https://maps.app.goo.gl/phdU7WNKvYq7b7ML9">
                                <span className="icon"><Icon path={mdiMapMarker} size={1.2} /></span>
                                <h2>{lang === "cs" ? "Adresa kanceláře" : "Adres biura"}</h2>
                                <span className="value">Roztocká 500,<br />
                                    514 01 Jilemnice</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </section>
            <section className="content-page" style={{ paddingTop: "0px" }}>
                <Content id="contact" />
            </section>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2532.1994955938094!2d15.50751209775016!3d50.60483046071573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470ebf0189e30677%3A0xf02dc41a828f4711!2sRoztock%C3%A1%20500%2C%20514%2001%20Jilemnice!5e0!3m2!1scs!2scz!4v1731601233373!5m2!1scs!2scz" width="100%" height="500" style={{ border: 0 }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
        </main>
        <Footer />
    </>;
}
